//GeneratorFlag:[NoChange]
import Product from './product';

export default {Product}
export{Product}